module.exports = __webpack_public_path__ + "static/media/Card.85a62781.svg";